import React, { useEffect, useState } from "react";
import Seo from "components/Seo";
import CustomerLayout from "./customerLayout";
import Button from "../../-components/common/Button";
import Input from "../../-components/common/Input";
import Editor from "../../../../../components/Editor";
import { useMorningAuthStore } from "../../../../../store/useMorningAuthStore";
import { usePostRegister } from "../../../../../hooks/morning/usePostRegister";
import { useLocation, useNavigate } from "react-router-dom";
import { usePutRegister } from "../../../../../hooks/morning/usePutRegister";
import { ReactComponent as Close } from "assets/morning/icon/close.svg";

const MorningRequestRegister = () => {
    const c_company = useMorningAuthStore(state => state.c_company);
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as { data?: any; listNo?: string } | null;

    const [showCompletePop, setShowCompletePop] = useState<boolean>(false);
    const [title, setTitle] = useState<string>("");
    const [num, setNum] = useState<string>("");
    const [company, setCompany] = useState<string>(c_company || "");
    const [value, setValue] = useState<any>("");
    const [memo, setMemo] = useState<string>("");
    const [tel, setTel] = useState<string>("");

    const { mutate } = usePostRegister(() => setShowCompletePop(true));
    const { mutate: modifyMutate } = usePutRegister(() => setShowCompletePop(true));

    const handleSubmit = () => {
        const payload = {
            category: "customer_4",
            subject: title,
            bl_no: num,
            company: company,
            contents: value,
            bigo: memo,
            phone: tel,
            ...(state?.data && { list_no: state?.listNo }),
        };
        if (state?.data) {
            modifyMutate(payload);
        } else mutate(payload);
    };

    useEffect(() => {
        if (!state?.data) return;

        setTitle(state.data.subject || "");
        setNum(state.data.bl_no || "");
        setCompany(state.data.company || "");
        setValue(state.data.contents || "");
        setMemo(state.data.bigo || "");
        setTel(state.data.mobile || "");
    }, [state?.data]);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="청구서수정요청" />
            <CustomerLayout>
                <div className="flex-1 bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:px-[4%] responsive1200:pt-[30px]">
                    <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500]">
                        청구서수정요청
                    </p>
                    <div className="bg-white items-center mt-12 w-full max-w-[1200px] px-12 py-6 rounded-2xl flex flex-col mb-6 responsive1200:my-[30px] responsive1200:px-[4%] responsive650:py-[10%]">
                        <div className="text-[#333] w-full text-[15px] border-t-2 border-black mt-10 responsive650:mt-0">
                            <div className="flex items-center h-[65px] border-b responsive650:flex-col responsive650:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive650:w-full">
                                    제목
                                </p>
                                <Input value={title} onChange={e => setTitle(e.target.value)} className="w-full p-2" />
                            </div>
                            <div className="flex items-center h-[65px] border-b responsive650:flex-col responsive650:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive650:w-full">
                                    운송장번호
                                </p>
                                <Input value={num} onChange={e => setNum(e.target.value)} className="w-full p-2" />
                            </div>
                            <div className="flex items-center h-[65px] border-b responsive650:flex-col responsive650:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive650:w-full">
                                    요청업체명
                                </p>
                                <Input value={company} onChange={e => setCompany(e.target.value)} className="w-full p-2" />
                            </div>
                            <div className="flex border-b responsive650:flex-col">
                                <p className="bg-[#f8f8f8]  border-r py-2 min-w-[165px] flex items-center justify-center">
                                    문의 및 요청사항
                                </p>
                                <div className="p-2 w-full">
                                    <Editor
                                        value={value}
                                        onChangeHandler={(val: string) => setValue(val)}
                                        bounds="#editor"
                                        className="[&_.ql-container]:min-h-[350px] h-auto responsive650:[&_.ql-container]:min-h-[150px]"
                                    />
                                </div>
                            </div>
                            <div className="flex items-center h-[65px] border-b responsive650:flex-col responsive650:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive650:w-full">
                                    비고
                                </p>
                                <Input value={memo} onChange={e => setMemo(e.target.value)} className="w-full p-2" />
                            </div>
                            <div className="flex items-center h-[65px] border-b responsive650:flex-col responsive650:h-auto">
                                <p className="bg-[#f8f8f8] border-r py-2 px-2.5 min-w-[165px] h-full flex items-center justify-center responsive650:w-full">
                                    연락 드릴 번호
                                </p>
                                <Input value={tel} onChange={e => setTel(e.target.value)} className="w-full p-2" />
                            </div>
                        </div>
                        <Button
                            onClick={handleSubmit}
                            className="mt-8 mb-10 border-none bg-[#264180] text-white w-full max-w-[400px] min-h-14 flex responsive650:mb-0"
                            size="L"
                        >
                            {state?.data ? "수정하기" : "접수하기"}
                        </Button>
                    </div>
                </div>
                {showCompletePop && (
                    <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <div className="absolute z-[100] mt-[34px] flex flex-col gap-8 bg-white border w-full max-w-[560px] p-10 rounded-lg shadow-lg overflow-hidden">
                            <div className="text-2xl flex items-center justify-between">
                                <p>{state?.data ? "수정되었습니다." : "접수되었습니다."}</p>
                                <Close onClick={() => setShowCompletePop(false)} className="cursor-pointer" />
                            </div>
                            <Button
                                onClick={() => {
                                    navigate("/customer/invoices-edit");
                                }}
                                className="w-full border-none bg-new text-white"
                                size="L"
                            >
                                확인
                            </Button>
                        </div>
                    </div>
                )}
            </CustomerLayout>
        </React.Fragment>
    );
};
export default MorningRequestRegister;
